import { clone } from 'lodash'

const colors = ['2F7FBC', '0D2847', '0A5D8D', '103F81'].map(hex => ({
  r: parseInt(hex.substring(0, 2), 16),
  g: parseInt(hex.substring(2, 4), 16),
  b: parseInt(hex.substring(4, 6), 16)
}))

const getRandomColor = () => colors[Math.floor(Math.random() * colors.length)]

const stepsBetweenColors = 250

export default class Pixel {
  x: number
  y: number

  color: { r: number; g: number; b: number }
  delta: { r: number; g: number; b: number }

  iterations: number

  constructor (x: number, y: number) {
    this.x = x
    this.y = y
    this.iterations = 0
    this.color = clone(getRandomColor())
    this.delta = { r: 0, g: 0, b: 0 }
    this.nextStep()
  }

  nextStep () {
    const next = getRandomColor()
    this.delta.r = (next.r - this.color.r) / stepsBetweenColors
    this.delta.g = (next.g - this.color.g) / stepsBetweenColors
    this.delta.b = (next.b - this.color.b) / stepsBetweenColors
  }

  update () {
    this.color.r += this.delta.r
    this.color.g += this.delta.g
    this.color.b += this.delta.b

    if (++this.iterations >= stepsBetweenColors) {
      this.nextStep()
      this.iterations = 0
    }
  }

  render (ctx: CanvasRenderingContext2D) {
    ctx.fillStyle = `rgb(${Math.floor(this.color.r)}, ${Math.floor(this.color.g)}, ${Math.floor(this.color.b)})`
    ctx.fillRect(this.x, this.y, 1, 1)
  }
}
